import { OnInit, Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'RemarksPopup',
    templateUrl: './RemarksPopup.html'
})
export class RemarksPopup implements OnInit {
    MAX_LENGTH = 5000;

    @Input() Model: string;
    @Input() EnableMaxLimit = false;

    constructor(protected activeModal: NgbActiveModal) { }

    ngOnInit() { }

    SetModel(existing: string, enableLimit: boolean) {
        this.Model = existing;
        this.EnableMaxLimit = enableLimit;
    }

    SubmitRemarks() {
        this.activeModal.close(this.Model)
    }

    Cancel() {
        this.activeModal.dismiss();
    }
}
